import { createContext, useContext } from 'react';

import { PhysicianData, ProviderLocation } from '../profile/profile.types';
import { StepOneFormData } from './components/step-one/schema';
import { StepTwoFormData } from './components/step-two/schema';
import { ConfirmationData } from './booking.types';

type StepOneData = StepOneFormData & {
  holdId?: string;
  dateTimeOfAppointment?: string;
  date?: string;
  appointmentId?: string;
  appointmentTypeLabel?: string;
  providerLocationId?: string;
  physician?: PhysicianData; // Todo: fix these
  location?: ProviderLocation;
};

export type BookingContextProps = {
  stepOneData: StepOneData;
  setStepOneData: React.Dispatch<React.SetStateAction<StepOneData>>;
  stepTwoData: StepTwoFormData;
  setStepTwoData: React.Dispatch<React.SetStateAction<StepTwoFormData>>;
  confirmationData: ConfirmationData | null;
  setLocation: (loc: ProviderLocation) => void;
  setConfirmationData: React.Dispatch<React.SetStateAction<ConfirmationData | null>>;
};

const contextError = 'useBookingContext must be used within a Booking provider!';
export const BookingContext = createContext<BookingContextProps | undefined>(undefined);

export const useBookingContext = (): BookingContextProps => {
  const context = useContext(BookingContext);

  if (!context) {
    throw new Error(contextError);
  }

  return context;
};
